import customHeaders, { getSpace } from "../../../common/headers";
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { KonstantinFeedbackHttps } from '../../../fetchUrls';
import useGeneralStore from "../../../store/general";
import './ModalConfirmationUnloading.scss'
import { ModalComponent } from "../ModalComponent/ModalComponent";

const ModalConfirmationUnloadingl = ({ setIsModal }) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const downloadAllTemplates = () => {
        const url = `${KonstantinFeedbackHttps}/feedbacks/answers/templates-report`

        fetch(url, { method: 'GET', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res?.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(({ filename, url }) => {
                window.open(url, '_blank')
                setIsModal(false)
            })
            .catch(err => console.error(err))
    }

    return (
        <ModalComponent
            title="Вы действительно хотите выгрузить все шаблоны"
            onClose={e => setIsModal(false)}
            style={{ maxWidth: '500px', height: 'auto' }}
            child={
                <div className='modal-confirmation-unloading'>
                    <ButtonBasic
                        grey
                        text='Нет, я передумал'
                        width='calc(50% - 6px)'
                        size='40px'
                        onClick={setIsModal}
                    />

                    <ButtonBasic
                        green
                        text='Да, хочу выгрузить'
                        width='calc(50% - 6px)'
                        onClick={downloadAllTemplates}
                    />

                </div>
            }
        />
    )
}

export { ModalConfirmationUnloadingl }